import React, { useState } from "react";
import "./ContactUs.css";

import officeIcon from "../../assets/contact-office.png";
import emailIcon  from "../../assets/contact-email.png";
import phoneIcon  from "../../assets/contact-phone.png";
import contactBg  from "../../assets/contact-bg.jpg";

const areaOptions = [
  "National Solar Programs",
  "Corporative Energy Models",
  "Rooftop Solar Solutions",
  "Partner With Us",
  "Carbon Credits Information",
  "Others",
];

const locationOptions = [
  "Hyderabad", "Bangalore", "Chennai", "Mumbai", "Delhi", "Pune",
];

const ChevronIcon = ({ open }) => (
  <svg
    className={`cu-chevron${open ? " open" : ""}`}
    width="16" height="16" viewBox="0 0 16 16" fill="none"
  >
    <path
      d="M4 6l4 4 4-4"
      stroke="#6D6E70" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

/* ── Thank You state ── */
const ThankYouCard = () => (
  <div className="cu-thankyou">
    {/* Green checkmark */}
    <div className="cu-ty-circle">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M8 20.5L16.5 29L32 13"
          stroke="#ffffff" strokeWidth="3.5"
          strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    </div>

    <h3 className="cu-ty-title">
      Thank You. We've Received Your Request.
    </h3>
    <p className="cu-ty-text">
      One of our solar experts will review your requirements
      and get back to you in 1‑2 days.
    </p>
  </div>
);

const ContactUs = () => {
  const [form, setForm] = useState({
    fullName: "", email: "", phone: "",
    location: "", area: "", message: "",
  });
  const [locationOpen, setLocationOpen] = useState(false);
  const [areaOpen,     setAreaOpen]     = useState(false);
  const [submitted,    setSubmitted]    = useState(false);

  const set = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const pick = (key, val, setter) => {
    setForm((f) => ({ ...f, [key]: val }));
    setter(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="cu-page">

      {/* ════════ LEFT ════════ */}
      <div className="cu-left">
        <div className="cu-left-top">
          <h1 className="cu-title">Start Your Solar Journey</h1>
          <p className="cu-subtitle">
            Speak with our experts to explore solar options, get a quote,
            or schedule a consultation — we're just a message away.
          </p>
        </div>

        <div className="cu-left-bottom">
          <div className="cu-contacts">
            {/* Office */}
            <div className="cu-contact-item">
              <img src={officeIcon} alt="" className="cu-contact-icon" />
              <p className="cu-contact-label">OFFICE</p>
              <p className="cu-contact-text">
                Plot No 1/C, Sy No 83/1, Raidurgam,<br />
                Knowledge City Road, Panmaktha,<br />
                Hyderabad – 500032
              </p>
            </div>

            {/* Email */}
            <div className="cu-contact-item">
              <img src={emailIcon} alt="" className="cu-contact-icon" loading="lazy" />
              <p className="cu-contact-label">EMAIL</p>
              <p className="cu-contact-text">care@truerenewables.in</p>
            </div>

            {/* Phone – col-1 row-2 */}
            <div className="cu-contact-item cu-contact-phone">
              <img src={phoneIcon} alt="" className="cu-contact-icon" loading="lazy" />
              <p className="cu-contact-label">PHONE NUMBER</p>
              <p className="cu-contact-text">+91 123456789</p>
            </div>
          </div>

          <div className="cu-socials">
            {[
              { label: "FACEBOOK",  url: "https://www.facebook.com" },
              { label: "LINKEDIN",  url: "https://www.linkedin.com" },
              { label: "TWITTER",   url: "https://www.twitter.com" },
              { label: "INSTAGRAM", url: "https://www.instagram.com" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="cu-social-link"
              >
                {s.label}
                <svg width="8.67" height="8.67" viewBox="0 0 13 13" fill="none">
                  <path
                    d="M1.4 13L11 3.4V12H13V0H1V2H9.6L0 11.6L1.4 13Z"
                    fill="#111111"
                  />
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* ════════ RIGHT ════════ */}
      <div className="cu-right">
        <img src={contactBg} alt="" className="cu-bg-img" loading="lazy" />

        <div className="cu-form-card">
          {submitted ? (
            <ThankYouCard />
          ) : (
            <form className="cu-form" onSubmit={handleSubmit} noValidate>

              {/* Full Name */}
              <div className="cu-field">
                <label className="cu-label">Full Name *</label>
                <input
                  className="cu-input" type="text"
                  placeholder="Enter your full name"
                  value={form.fullName} onChange={set("fullName")}
                  required
                />
              </div>

              {/* Email + Phone */}
              <div className="cu-row-2">
                <div className="cu-field">
                  <label className="cu-label">Business Email *</label>
                  <input
                    className="cu-input" type="email"
                    placeholder="you@company.com"
                    value={form.email} onChange={set("email")}
                    required
                  />
                </div>

                <div className="cu-field">
                  <label className="cu-label">Phone number *</label>
                  <div className="cu-phone-row">
                    <span className="cu-phone-prefix">
  IND
  <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
    <path
      d="M3 4.5l3 3 3-3"
      stroke="#111111" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
  <span className="cu-phone-divider" />
  +91
</span>
                    <input
                      className="cu-input cu-phone-input" type="tel"
                      value={form.phone} onChange={set("phone")}
                    />
                  </div>
                </div>
              </div>

              {/* Location */}
              <div className="cu-field">
                <label className="cu-label">Location*</label>
                <div
                  className="cu-select"
                  onClick={() => {
                    setLocationOpen((o) => !o);
                    setAreaOpen(false);
                  }}
                >
                  <span className={form.location ? "cu-sel-val" : "cu-sel-ph"}>
                    {form.location || "Select your location"}
                  </span>
                  <ChevronIcon open={locationOpen} />
                  {locationOpen && (
                    <div className="cu-dropdown">
                      {locationOptions.map((opt) => (
                        <div
                          key={opt} className="cu-dd-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            pick("location", opt, setLocationOpen);
                          }}
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Area of Interest */}
              <div className="cu-field">
                <label className="cu-label">Select Area Of Interest*</label>
                <div
                  className="cu-select"
                  onClick={() => {
                    setAreaOpen((o) => !o);
                    setLocationOpen(false);
                  }}
                >
                  <span className={form.area ? "cu-sel-val" : "cu-sel-ph"}>
                    {form.area || "Select any one"}
                  </span>
                  <ChevronIcon open={areaOpen} />
                  {areaOpen && (
  <div className="cu-dropdown cu-dropdown-radio">
    {areaOptions.map((opt) => (
      <label
        key={opt}
        className="cu-dd-radio-item"
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="radio"
          name="area-interest"
          value={opt}
          checked={form.area === opt}
          onChange={() => pick("area", opt, setAreaOpen)}
          className="cu-radio-input"
        />
        <span className="cu-radio-circle">
          {form.area === opt && <span className="cu-radio-dot" />}
        </span>
        <span className="cu-radio-label">{opt}</span>
      </label>
    ))}
  </div>
)}
                </div>
              </div>

              {/* Message */}
              <div className="cu-field">
                <label className="cu-label">Any message (optional)</label>
                <textarea
                  className="cu-textarea" rows={3}
                  placeholder="Write your message here"
                  value={form.message} onChange={set("message")}
                />
              </div>

              <button type="submit" className="cu-submit">
                Submit Form
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;